import React from "react";

const P: Record<string, React.ReactNode> = {
  Round: <circle cx="20" cy="20" r="14" />,
  Oval: <ellipse cx="20" cy="20" rx="10" ry="15" />,
  Emerald: <path d="M13 5h14l5 5v20l-5 5H13l-5-5V10z" />,
  Cushion: <rect x="6" y="6" width="28" height="28" rx="9" />,
  "Elongated Cushion": <rect x="10" y="4" width="20" height="32" rx="8" />,
  Pear: <path d="M20 4C14 13 9 19 9 25a11 11 0 0 0 22 0c0-6-5-12-11-21z" />,
  Princess: <rect x="7" y="7" width="26" height="26" />,
  Radiant: <path d="M12 5h16l4 4v22l-4 4H12l-4-4V9z" />,
  Marquise: <path d="M20 3c8 7 9 13 9 17s-1 10-9 17c-8-7-9-13-9-17s1-10 9-17z" />,
  Heart: <path d="M20 34S6 25 6 15a7 7 0 0 1 14-2 7 7 0 0 1 14 2c0 10-14 19-14 19z" />,
  Asscher: <path d="M12 6h16l6 6v16l-6 6H12l-6-6V12z" />,
};

export const ShapeIcon = ({ shape, size = 40 }: { shape: string; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.1" aria-hidden="true">
    {P[shape] || P.Round}
  </svg>
);
